import { Command } from 'commands/Commands';

export class DeleteBusiness extends Command {
  type: string = 'DeleteBusiness';
  priority: number = 100;
}
